import useLanguage from './useLanguage';
import { container } from '@intigral/domain';
import { useQuery } from '@tanstack/react-query';
import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';
import { DI } from '@intigral/constant/config/DIContainer';
import { useMemo } from 'react';

const useFooterMenu = () => {
    const language = useLanguage();
    const customService = container.resolve<ICustomConfigurationService>(DI.SERVICES.ICustomConfigurationService);

    const { data } = useQuery({
        queryKey: ['footerMenu', language],
        queryFn: async () => {
            const result = await customService.getFooterMenuContent();
            return result || { footerMenu: [], socialMediaLinks: [], appLinks: [] };
        },
    });

    const navlinks = useMemo(() => {
        return data?.footerMenu?.map((link) => ({
            text: link?.label?.[language],
            link: link?.url?.[language],
            image: '',
            target: link?.target,
        }));
    }, [data?.footerMenu, language]);

    const termsLink = useMemo(() => {
        return navlinks?.find((item) => item?.link?.includes('terms'))?.link;
    }, [navlinks]);

    return { termsLink };
};

export default useFooterMenu;
